import { render, staticRenderFns } from "./CompanyDeleted.vue?vue&type=template&id=dc8fdbc0"
import script from "./CompanyDeleted.vue?vue&type=script&lang=ts"
export * from "./CompanyDeleted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports